import { actionTypes } from '../constants'

const SelectedActionIcon = ({ actionType, size = 16 }) => {
  const Icon = actionTypes[actionType]?.icon

  if (!Icon) {
    return null
  }

  return <Icon size={size} />
}

export default SelectedActionIcon
